export const season = [
    'Summer',
    'Kharif',
    'Rabi',
    'Annual',
    'Perenial',
    'Semi_perennial'
]


export const year = ()=> {
    let allYear = []
    let current_year =  new Date().getFullYear()
    for ( let i = 0; i < 5; i++){
        let _year =(current_year -i)
        allYear.push(_year.toString())
    }
    allYear.sort()
    return allYear
}

export const rater_layer_list = [
                                'None',
                                'True_color',
                                'Ndvi', 
                                'Moisture_index', 
                                'Planetsync_vegetation', 
                                'Swir',
                                'Savi'
                                ]

                                // mapbox://styles/mapbox/satellite-streets-v12
export const mapStyleLlist = {
    satellite: 'satellite-v9',
    streets: 'streets-v12',
    satellite_street:'satellite-streets-v12',
    outdoors: 'outdoors-v12',
    light: 'light-v11',
    dark: 'dark-v11',
    navigation_day:'navigation-day-v1',
    navigation_night:'navigation-night-v1',
    // terrain_outlined:'mapbox-terrain-v2'
}

export const vector_layer_list = ['Userproject','NavLayer','State', 'District', 'Subdistrict', 
                                  'Village', 'Pincode','Pincode_label','Surveypolygons',
                                  'WaterBodies','Labels', 'ElevationLayer']

export const sidebarwith = 300


export const rater_layer_label = [
    {label: 'None', value: 'None'},
    {label: 'True_color', value: 'TRUE_COLOR'},
    {label: 'Ndvi', value: 'NDVI'},
    {label: 'Moisture_index', value: 'MOISTURE_INDEX'},
    {label: 'Planetsync_vegetation', value: 'NDVI_GREEN'},
    {label: 'Swir', value: 'SWIR'},
    {label: 'Savi', value: 'MSAVI2_L2A'}
]

export const raster_url = {
    'AWV': 'https://creodias.sentinel-hub.com/ogc/wms',
    'NDVI': 'https://services.sentinel-hub.com/ogc/wms',
    'TRUE_COLOR': 'https://services.sentinel-hub.com/ogc/wms',
    'MOISTURE_INDEX': 'https://services.sentinel-hub.com/ogc/wms',
    'MSAVI2': 'https://services.sentinel-hub.com/ogc/wms',
    'MSAVI2_L2A': 'https://services.sentinel-hub.com/ogc/wms',
    'SWIR': 'https://services.sentinel-hub.com/ogc/wms',
    'NDVI_GREEN': 'https://services.sentinel-hub.com/ogc/wms',
}   


export const Landuse = [
    { label: "Industrial", id: 1 },
    { label: "Wasteland", id: 2 },
    { label: "Shrubs", id: 3 },
    { label: "Commercial", id: 4 },
    { label: "Woodland", id: 5 },
    { label: "Grass land", id: 6 },
    { label: "Waterbody", id: 4 },
    { label: "Re-generation", id: 7 },
    { label: "Residential", id: 8 },
    { label: "Agriculture", id: 9 }
  ];
  
  export const CropGroup = [
    { label: "Plantation", id: 1},
    { label: "Oil_Seeds", id: 2 },
    { label: "Horticulture", id: 3 },
    { label: "Vegetables", id: 4 },
    { label: "Cereals", id: 5 },
    { label: "Pulses", id: 6 },
    { label: "Annual_Plants", id: 7 },
    { label: "Biennial_Plants", id: 8 },
    { label: "Commercial", id: 9 },
    { label: "Fodder", id: 10 },
    { label: "Spices", id: 11 },
    { label: "Seeds", id: 12 },
    { label: "Grove", id: 13 },
    { label: "Forest", id: 14 },
  
  ]
  
  export const Croplist = [
    { label: "Cotton", id: 1 },
    { label: "Soyabean", id: 2 },
    { label: "Shorghum", id: 3 },
    { label: "Paddy", id: 4 },
    { label: "Wheat", id: 5 },
    { label: "Millet", id: 6 },
    { label: "Mustered", id: 7 },
    { label: "Rabi cereals", id: 8 },
    { label: "Red grams", id: 9 },
    { label: "Lentil", id: 10 },
    { label: "Greengram", id: 11 },
    { label: "Chilli", id: 12 },
    { label: "Onion", id: 13 },
    { label: "Garlic", id: 14 },
    { label: "Tomato", id: 15 },
    { label: "Coriander", id: 16 },
    { label: "Sugarcane", id: 17 },
    { label: "Pomegranate", id: 18 },
    { label: "Grape", id: 19 },
    { label: "Cashew", id: 20 },
    { label: "Coconut", id: 21 },
    { label: "Citrusfruit", id: 22 },
    { label: "Mango", id: 23 },
    { label: "Orange", id: 24 },
    { label: "Woodland", id: 25 },
    { label: "Banana", id: 26 },
    { label: "Potato", id: 27 },
  ];
  
  export const Season = [
    { label: "Winter", id: 1 },
    { label: "Summer", id: 2 },
    { label: "Rainy", id: 3 },
    { label: "Annual", id: 4 },
    { label: "Semi-perennial", id: 5 },
    { label: "perennial", id: 6 },
   
  ];
  
  export const CapacityType = [
    { label: "Solar", id: 1 },
    { label: "Wind", id: 2 },
    { label: "Hydel", id: 3 },
    { label: "Biomass", id: 4 },
   
  ];

























